import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Play } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const ProjectCard = ({ project, className = "" }) => {
  const { t, lp } = useLang();
  const accent = project.branch === "audiovisual" ? "#edaa51" : "#26775e";

  return (
    <Link
      to={lp(`/proyectos/${project.slug}`)}
      data-testid={`project-card-${project.slug}`}
      className={`group relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 min-h-[400px] flex flex-col justify-end transition-all duration-500 hover:-translate-y-1.5 hover:border-white/25 ${className}`}
      style={{ ["--acc"]: accent }}
    >
      <div className="absolute inset-0">
        <img
          src={project.image}
          alt={project.title}
          loading="lazy"
          className="w-full h-full object-cover opacity-85 group-hover:opacity-100 group-hover:scale-110 transition-all duration-[900ms] ease-out"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/45 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: `linear-gradient(to top, ${accent}30, transparent)` }} />
      </div>

      {project.vimeo && (
        <div className="absolute top-5 right-5 z-10 w-11 h-11 rounded-full bg-white/10 backdrop-blur flex items-center justify-center border border-white/20 group-hover:bg-brand-gold group-hover:text-ink transition-colors">
          <Play size={16} className="ml-0.5" />
        </div>
      )}

      <div className="relative z-10 p-7">
        <span
          className="inline-block font-display text-[0.65rem] font-bold uppercase tracking-[0.2em] mb-3"
          style={{ color: accent }}
        >
          {t(project.kicker)}
        </span>
        <h3 className="font-display text-2xl md:text-3xl font-extrabold text-white leading-tight">
          {project.title}
        </h3>
        <p className="mt-2 text-white/60 font-body text-sm max-w-md">{t(project.summary)}</p>
        <span className="mt-5 inline-flex items-center gap-2 font-display text-xs font-bold uppercase tracking-widest text-white/70 group-hover:text-white transition-colors">
          {t({ es: "Ver proyecto", en: "View project" })}
          <ArrowUpRight size={15} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" style={{ color: accent }} />
        </span>
      </div>
    </Link>
  );
};

export default ProjectCard;
